import numbro from "numbro";
import Database from "../db";
import { FileDoc } from "../db/File";
import { AppStore } from "../redux";
import { calculateReport, fetchAccountData } from "../redux/report";
import ExtfLoader from "./ExtfLoader";

export default class App {
  public readonly db = Database.db;
  public readonly init: Promise<true>;
  public fileIdCounter = 0;

  constructor(readonly store: AppStore) {
    console.log("Booting application");
    this.init = this._init();
  }

  public async loadFiles(acceptedFiles: File[]) {
    this.store.dispatch({ type: "BEGIN_LOADING" });
    for (const f of acceptedFiles) {
      const fileId = ++this.fileIdCounter;
      const docs: object[] = [];
      const file = await ExtfLoader.readFile(f, async (row, meta) => {
        const d = {
          _id: "am:" + numbro(fileId).format("000") + ":" + numbro(meta.lineNumber).format("0000000"),
          ...row
        };
        // await this.db.put(d);
        docs.push(d);
        // console.log(meta.lineNumber, "saved to db");
      });
      const fd = {
        _id: "f:" + numbro(fileId).format("000"),
        fileName: file.fileName
      };
      docs.push(fd);
      console.log("put into db:", fd);
      await this.db.bulkDocs(docs);
      // await this.db.put(fd);
      console.log(file.fileName, "saved to db");
    }
    console.log("all files processed");
    this.updateFromDb();
  }
  public async removeFile(id: string) {
    const fileId = id.substr(2);
    this.db.allDocs({ startkey: `am:${fileId}:`, endkey: `am:${fileId}:\ufff0`, include_docs: true }).then(result =>
      this.db.bulkDocs(
        result.rows.map(row => {
          return { _id: row.id, _rev: row.doc!._rev, _deleted: true };
        })
      )
    );
    await this.db.get(id).then(doc => this.db.remove(doc));
    await this.db.compact();
    return this.updateFromDb();
  }
  public async reset() {
    await this.db.destroy();
    location.reload();
  }

  /**
   * TODO, Das ist kacke. redux-saga dürfte doch besser sein
   * @param accountNo
   */
  public async selectAccountData(accountNo: number) {
    this.store.dispatch({ type: "BEGIN_LOADING" });
    await this.store.dispatch(fetchAccountData(this.db, accountNo));
    this.store.dispatch({ type: "END_LOADING" });
  }

  private async updateFromDb() {
    this.store.dispatch({ type: "BEGIN_LOADING" });
    console.log("Beginning process from DB");
    const loadedFiles = (await this.db.allDocs<FileDoc>({ startkey: "f:", endkey: "f:\ufff0", include_docs: true })).rows.map(m => {
      const file = m.doc!;
      this.fileIdCounter = Math.max(this.fileIdCounter, +file._id.substr(2));
      return file;
    });
    this.store.dispatch({ type: "UPDATE_FILE_LIST", payload: loadedFiles });
    console.log("File-List loaded from DB");
    console.log("Beginning calculating");
    await this.store.dispatch(calculateReport(this.db));
    console.log("Calculation done");
    this.store.dispatch({ type: "END_LOADING" });
  }

  private async _init(): Promise<true> {
    console.log("Database Status:", await this.db.info());
    await this.updateFromDb();
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/index.ts